<template>
  <div class="sign-pg">
    <div class="sign-row">
      <div class="sign-form-top">
        <h2>{{ $t("Создайте аккаунт") }}</h2>
      </div>
      <form class="register-form" @submit.prevent="validateForm">
        <div class="form-group">
          <label class="sr-only" for="secondName">{{ $t("Фамилия") }}</label>
          <input
            id="secondName"
            name="secondName"
            type="text"
            v-model.trim="secondName"
            class="form-control"
            :class="{
              invalid: $v.secondName.$dirty && !$v.secondName.required
            }"
            :aria-invalid="$v.secondName.$dirty && !$v.secondName.required ? 'true' : 'false'"
            :aria-describedby="$v.secondName.$dirty && !$v.secondName.required ? 'secondName-error' : null"
            :placeholder='$t("Фамилия")'
          />
          <small
            id="secondName-error"
            class="helper-text invalid"
            v-if="$v.secondName.$dirty && !$v.secondName.required"
          >
            {{ $t("Поле Фамилия не должно быть пустым") }}
          </small>
        </div>
        <div class="form-group">
          <label class="sr-only" for="firstName">{{ $t("Имя") }}</label>
          <input
            id="firstName"
            type="text"
            v-model.trim="firstName"
            class="form-control"
            :class="{
              invalid: $v.firstName.$dirty && !$v.firstName.required
            }"
            :aria-invalid="$v.firstName.$dirty && !$v.firstName.required ? 'true' : 'false'"
            :aria-describedby="$v.firstName.$dirty && !$v.firstName.required ? 'firstName-error' : null"
            :placeholder='$t("Имя")'
          />
          <small
            id="firstName-error"
            class="helper-text invalid"
            v-if="$v.firstName.$dirty && !$v.firstName.required"
          >
            {{ $t("Поле Имя не должно быть пустым") }}
          </small>
        </div>
        <div class="form-group">
          <label class="sr-only" for="lastName">{{ $t("Отчество") }}</label>
          <input
            id="lastName"
            type="text"
            v-model.trim="lastName"
            class="form-control"
            :placeholder='$t("Отчество")'
          />
        </div>
        <div class="form-group">
          <label class="sr-only" for="address">{{ $t("Адрес") }}</label>
          <input
            id="address"
            type="text"
            v-model.trim="address"
            class="form-control"
            :class="{ invalid: $v.address.$dirty && !$v.address.required }"
            :aria-invalid="$v.address.$dirty && !$v.address.required ? 'true' : 'false'"
            :aria-describedby="$v.address.$dirty && !$v.address.required ? 'address-error' : null"
            :placeholder='$t("Адрес")'
          />
          <small
            id="address-error"
            class="helper-text invalid"
            v-if="$v.address.$dirty && !$v.address.required"
          >
            {{ $t("Поле Адрес не должно быть пустым") }}
          </small>
        </div>
        <div class="form-group">
          <label class="sr-only" for="email">Email</label>
          <input
            id="email"
            type="text"
            v-model.trim="email"
            class="form-control"
            :class="{
              invalid:
                ($v.email.$dirty && !$v.email.required) ||
                ($v.email.$dirty && !$v.email.email)
            }"
            :aria-invalid="$v.email.$dirty && (!$v.email.required || !$v.email.email) ? 'true' : 'false'"
            :aria-describedby="$v.email.$dirty && (!$v.email.required || !$v.email.email) ? 'email-error' : null"
            placeholder="Email"
          />
          <small
            id="email-error"
            class="helper-text invalid"
            v-if="$v.email.$dirty && !$v.email.required"
          >
            {{ $t("Поле Email не должно быть пустым") }}
          </small>
          <small
            id="email-error"
            class="helper-text invalid"
            v-else-if="$v.email.$dirty && !$v.email.email"
          >
            {{ $t("Неверный e-mail. Попробуйте еще") }}
          </small>
        </div>
        <div class="form-group">
          <label class="sr-only" for="nickName">{{ $t("Логин") }}</label>
          <input
            id="nickName"
            type="text"
            v-model.trim="nickName"
            class="form-control"
            :class="{ invalid: $v.nickName.$dirty && !$v.nickName.required }"
            :aria-invalid="$v.nickName.$dirty && !$v.nickName.required ? 'true' : 'false'"
            :aria-describedby="$v.nickName.$dirty && !$v.nickName.required ? 'nickName-error' : null"
            :placeholder='$t("Логин")'
          />
          <small
            id="nickName-error"
            class="helper-text invalid"
            v-if="$v.nickName.$dirty && !$v.nickName.required"
          >
            {{ $t("Поле Логин не должно быть пустым") }}
          </small>
        </div>
        <div class="form-group">
          <label class="sr-only" for="password">{{ $t("Пароль") }}</label>
          <input
            id="password"
            type="password"
            v-model.trim="password"
            class="form-control"
            :class="{
              invalid:
                ($v.password.$dirty && !$v.password.required) ||
                ($v.password.$dirty && !$v.password.minLength)
            }"
            :aria-invalid="$v.password.$dirty && (!$v.password.required || !$v.password.minLength) ? 'true' : 'false'"
            :aria-describedby="$v.password.$dirty && (!$v.password.required || !$v.password.minLength) ? 'password-error' : null"
            :placeholder='$t("Пароль")'
          />
          <small
            id="password-error"
            class="helper-text invalid"
            v-if="$v.password.$dirty && !$v.password.required"
          >
            {{ $t("Пароль должен содержать не менее 8 символов букв латинского алфавита и цифр, не менее 1 буквы и не менее 1 цифры. Попробуйте еще") }}
          </small>
          <small
            id="password-error"
            class="helper-text invalid"
            v-else-if="$v.password.$dirty && !$v.password.minLength"
          >
            {{ $t("Пароль должен содержать не менее") }}
            {{ $v.password.$params.minLength.min }} {{ $t("символов") }}. {{ $t("Сейчас он") }}
            {{ password.length }}
          </small>
        </div>
        <div class="form-group">
          <label class="sr-only" for="repeatPassword">{{ $t("Повторите пароль") }}</label>
          <input
            id="repeatPassword"
            type="password"
            v-model.trim="repeatPassword"
            class="form-control"
            :class="{
              invalid:
                ($v.password.$dirty && !$v.password.required) ||
                ($v.repeatPassword.$dirty && password !== repeatPassword)
            }"
            :aria-invalid="$v.repeatPassword.$dirty && password !== repeatPassword ? 'true' : 'false'"
            :aria-describedby="$v.repeatPassword.$dirty && password !== repeatPassword ? 'repeatPassword-error' : null"
            :placeholder='$t("Повторите пароль")'
          />
          <small
            id="repeatPassword-error"
            class="helper-text invalid"
            v-if="$v.repeatPassword.$dirty && password !== repeatPassword"
          >
            {{ $t("Пароль должен совпадать. Попробуйте еще") }}
          </small>
        </div>
        <div class="form-captcha">
          <vue-recaptcha
            ref="recaptcha"
            size="invisible"
            :sitekey="sitekey"
            @verify="register"
            @expired="onCaptchaExpired"
          />
        </div>
        <button type="submit" class="btn btn-default grad">
          {{ $t("зарегистрироваться") }}
        </button>
        <div class="sign-form-bottom">
          <div class="soc-media">
            <p>{{ $t("или") }} {{ $t("зарегистрироваться через") }} </p>
            <button
              class="btn-google"
              type="button"
              :aria-label="$t('зарегистрироваться через') + ' Google'"
              @click="authenticate('google')"
            >
              <i class="google-icon" aria-hidden="true"></i>
            </button>
<!--            <button class="btn-facebook" type="button" @click="authenticate('facebook')">-->
<!--              <i class="pro-icon-facebook"></i>-->
<!--            </button>-->
          </div>
          <p>
            <small>
              {{ $t("Нажимая кнопку Зарегистрировать аккаунт или, регистрируясь через Facebook или Gmail, вы принимаете") }}
              <a href="#">{{ $t("Пользовательское соглашение") }}</a>
            </small>
          </p>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {email, required, minLength, sameAs} from 'vuelidate/lib/validators'
import VueRecaptcha from 'vue-recaptcha'
import messages from '@/utils/messages'
import {Trans} from "@/plugins/Translation"

export default {
  name: 'register',
  components: {
    VueRecaptcha
  },
  data: () => ({
    firstName: '',
    secondName: '',
    lastName: '',
    nickName: '',
    email: '',
    address: '',
    password: '',
    repeatPassword: '',
    userId: '',
    sitekey: process.env.VUE_APP_RECAPTCHA_TOKEN
  }),
  metaInfo () {
    return {
      title: this.$i18n.t('RegisterTitleSEO'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: this.$i18n.t('RegisterDescriptionSEO'),
      }, {
        vmid: 'keywords',
        name: 'keywords',
        content: this.$i18n.t('RegisterKeywordsSEO'),
      }]
    }
  },
  validations: {
    firstName: { required },
    secondName: { required },
    lastName: {},
    nickName: { required },
    address: { required },
    email: { email, required },
    password: { required, minLength: minLength(8) },
    repeatPassword: {
      sameAsPassword: sameAs('password')
    }
  },
  mounted() {
    if (messages[this.$route.query.message]) {
      this.$message(messages[this.$route.query.message])
    }
  },
  created() {
    this.scrollToTop()
  },
  methods: {
    persist() {
      localStorage.setItem('email', this.$event.target.value)
    },
    register(recaptchaToken) {
      if (!this.validateForm()) {
        return
      }

      const registerData = {
        firstName: this.firstName,
        secondName: this.secondName,
        lastName: this.lastName,
        nickName: this.nickName,
        address: this.address,
        email: this.email,
        pass: this.password,
        userId: this.userId,
        recaptchaToken: recaptchaToken
      }

      this.$store
        .dispatch('register', registerData)
        .then(() => {
          this.$router.push(Trans.i18nRoute({ name: 'success-register' }))
        })
        .catch((e) => {
          // this.error.push(e)
          if (e.response.status === 409) {
            this.$noty.error(this.$i18n.t(e.response.data.message), {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
            return
          }
          //тут будем обрабатывать ошибки
          this.$router.push(Trans.i18nRoute({
              name: 'error',
              params: {
                status: e.response.status
              }
            }))
        })
    },
    // Валидация формы
    validateForm() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      this.$refs.recaptcha.execute()
      return true
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset()
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    authenticate: function (provider) {
      this.$auth.link(provider).then((authResponse) => {
        if (authResponse.errors) {
          this.$noty.error(authResponse.errors, {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
          return
        }

        this.firstName = authResponse.user.first_name
        this.secondName = authResponse.user.second_name
        this.email = authResponse.user.email
        this.userId = authResponse.user.id
        this.nickName = authResponse.user.nick_name

      })
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError() {
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    }
  }
}
</script>
